<section>
  <div class="wrapper">
    <div class="mt_78">
      <div class="headerBox">
        <div class="header">EC2 Farm List</div>
        <div class="camera-list-table">
          <button mat-raised-button class="edit-btn new-button" aria-label="Add EC2 Farm" (click)="addFarmData()"
            *ngIf="editCameraConfig">
            <mat-icon aria-hidden="false" aria-label="add icon">add</mat-icon>
            Add
          </button>
        </div>
      </div>
      <div class="camera-list-table">
        <div class="mat-elevation-z8 table-pagination">
          <table mat-table [dataSource]="dataSource" class="mat-elevation w100" matSort matSortActive="created"
            matSortDisableClear matSortDirection="desc">
            <!-- Position Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef> ID </th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="nodeName">
              <th mat-header-cell *matHeaderCellDef> Node Name </th>
              <td mat-cell *matCellDef="let element"> {{element.nodeName}} </td>
            </ng-container>

            <ng-container matColumnDef="instanceId">
              <th mat-header-cell *matHeaderCellDef> Instance ID </th>
              <td mat-cell *matCellDef="let element"> {{element.instanceId}} </td>
            </ng-container>

            <ng-container matColumnDef="privateIp">
              <th mat-header-cell *matHeaderCellDef> Private IP </th>
              <td mat-cell *matCellDef="let element"> {{element.privateIp}} </td>
            </ng-container>

            <!-- Public IP Column -->
            <ng-container matColumnDef="publicIp">
              <th mat-header-cell *matHeaderCellDef> Public IP </th>
              <td mat-cell *matCellDef="let element"> {{element.publicIp}} </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="textAlignEnd">Action </th>
              <td mat-cell *matCellDef="let element" class="textAlignEnd">
                <button mat-raised-button class="edit-btn" type="button" (click)="updateFarmById(element)"
                  *ngIf="editCameraConfig"
                  matTooltip="Edit">
                  <mat-icon aria-hidden="false" aria-label="add icon">mode_edit_outline</mat-icon>
                </button>
                <!-- <button mat-raised-button class="delete-btn ml_10"  type="button"
                  (click)="deleteFarmById(element)">
                  <mat-icon aria-hidden="false" aria-label="add icon">delete</mat-icon>
                  Delete
                </button> -->
                <button mat-raised-button class="delete-btn ml_10" type="button" (click)="deleteFarmById(element)"
                  *ngIf="editCameraConfig"
                  matTooltip="Delete">
                  <mat-icon aria-hidden="false" aria-label="add icon">delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <!-- Symbol Column -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="no_record_found_msg" *ngIf="dataSource.data.length === 0">
            No Records Found!
          </div>
          <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]" [pageSize]="pageSize" [length]="totalRecords"
            [pageIndex]="pageIndex" (page)="changePaging($event)" aria-label="Select page of users">
          </mat-paginator>
        </div>
      </div>
    </div>
    <!-- <button type="button" (click)="editDeviceInSite()">edit new</button> -->
  </div>
</section>